import {createStrokeSVG} from './TEMPLATE'

// iconoir: tree
export const Tree_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M12 22L12 14M12 10L12 14M12 14L16 12',
    'M17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7',
    'M12 18H7.5C4.46243 18 2 15.5376 2 12.5C2 9.46243 4.46243 7 7.5 7H9',
    'M12 18H16.5C19.5376 18 22 15.5376 22 12.5C22 9.63102 19.8033 7.27508 17 7.02246',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})
